import { useState } from "react";
import Moment from "react-moment";
import { useEffect } from "react";
import AddBlogPost from "./AddBlogPost";
import { Form, Table } from "react-bootstrap";
import UseToggle from "../../../../Hooks/UseToggle";
import ToolBar from "../../../Componant/ToolBar";
import { blogPostServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogPostServices";
import SingleBlogPost from "./SingleBlogPost";

const BlogPostList = ({ blogCategories }) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [blogPosts, setBlogPosts] = useState([]);
  const [blogPostData, setBlogPostData] = useState("");
  const [blogPostCount, setBlogPostCount] = useState(0);
  const [blogPostIds, setBlogPostIds] = useState([]);

  const toggleSingle = (id) => {
    setBlogPostIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (blogPostIds.length === blogPostCount) {
      setBlogPostIds([]);
    } else {
      setBlogPostIds(blogPosts.map((c) => c._id));
    }
  };

  const isAllChecked =
    blogPostCount > 0 && blogPostIds.length === blogPostCount;
  const isChecked = (id) => blogPostIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(blogPostCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, blogPostCount);

  const getBlogPostList = async () => {
    setLoader(true);
    let data = await blogPostServices.getBlogPostList(
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setBlogPosts(data?.data || []);
    setBlogPostCount(data?.count || 0);
    setLoader(false);
  };

  useEffect(() => {
    getBlogPostList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={blogPostIds}
        setCheckedIds={setBlogPostIds}
        showPreview={showPreview}
        setShowPreview={setShowPreview}
        setSelected={setBlogPostData}
        start={start}
        end={end}
        totalItems={blogPostCount}
        page={pageNumber}
        setPage={setPageNumber}
        setPageSize={setItemsPerPage}
        pageSize={itemsPerPage}
        totalPages={totalPages}
        addField
        editField
      />

      <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
        <div
          className={`table-section overflow-auto bg-white ${showPreview ? "border-end" : ""}`}
          style={{ height: "calc(100vh - 182px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th style={{ width: "30%" }}>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Title</div>
                  </div>
                </th>
                {!blogPostData && (
                  <>
                    <th>Category</th>
                    <th>Sub Category</th>
                    <th>Post By</th>
                    <th>Post Date | Time</th>
                    <th>Update Date | Time</th>
                    <th>Status</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {blogPosts.map((item) => (
                <tr
                  key={item._id}
                  className={`contact-row ${blogPostData?._id === item._id ? "active" : ""}`}
                  onClick={() => {
                    setBlogPostData(item);
                    setShowPreview(true);
                  }}
                >
                  <td className="text-truncate text-wrap" style={{ maxWidth: 100 }}>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(item._id)}
                          onChange={() => toggleSingle(item._id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>
                        <div className="fw-medium">{item.title}</div>
                        <small className="text-muted">{item.shortDescription}</small>
                      </div>
                    </div>
                  </td>

                  {!blogPostData && (
                    <>
                      <td>{item.categoryName}</td>
                      <td>{item.subCategoryName}</td>
                      <td>{item.createdByName}</td>
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {item?.createdAt}
                        </Moment>
                      </td>
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {item?.updatedAt}
                        </Moment>
                      </td>
                      <td>
                        <span
                          className={`text-capitalize badge ${item.status === "publish" ? "bg-success" : item.status === "inactive" ? "bg-danger" : "bg-warning text-dark"}`}
                        >
                          {item.status}
                        </span>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className={`preview-section ${showPreview ? "open" : ""}`}>
          {blogPostData && (
            <SingleBlogPost
              postId={blogPostData?.postId}
              blogCategories={blogCategories}
              getBlogPostList={getBlogPostList}
            />
          )}
        </div>
      </div>
      <AddBlogPost
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add New Blog Post`}
        blogCategories={blogCategories}
        getBlogPostList={getBlogPostList}
      />
    </>
  );
};

export default BlogPostList;
